import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { enableMiddlewareSMO } from '@api/middlewareSMO';

import { IMiddlewareSMO } from '@interfaces/middlewareSMO/middlewareSMO';

import { ESnackbarTypes } from '@enums/common';

import { MIDDLEWARE_SMO_ENABLE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateMiddlewareSMO from './useInvalidateMiddlewareSMO';

interface IUseMutateMiddlewareSMOEnableProps {
	handleCloseModal: () => void;
	middleware: IMiddlewareSMO | null;
}

interface IUseMutateMiddlewareSMOEnableReturned {
	enableMiddlewareSMO: (id: string) => void;
	isLoadingEnableMiddlewareSMO: boolean;
}

const useMutateMiddlewareSMOEnable = ({
	handleCloseModal,
	middleware,
}: IUseMutateMiddlewareSMOEnableProps): IUseMutateMiddlewareSMOEnableReturned => {
	const dispatch = useAppDispatch();
	const invalidateMiddlewareSMO = useInvalidateMiddlewareSMO();

	const {
		isLoading,
		mutate,
	} = useMutation<string>({
		mutationKey: [MIDDLEWARE_SMO_ENABLE],
		mutationFn: enableMiddlewareSMO,
		onSuccess: () => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.middlewareActivated(middleware?.systemId),
				type: ESnackbarTypes.success,
			}));

			return invalidateMiddlewareSMO();
		},
	});

	return {
		enableMiddlewareSMO: mutate,
		isLoadingEnableMiddlewareSMO: isLoading,
	};
};

export default useMutateMiddlewareSMOEnable;
